import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import InstallPrompt from "@/components/InstallPrompt";
import ChatWidget from "@/components/ChatWidget";
import GoogleReviewBadge from "@/components/GoogleReviewBadge";

const Layout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  // Hide chat widget on admin/driver dashboards & auth callback
  const hideChat = /^\/(admin|driver|auth\/)/.test(pathname);

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppButton />
      <GoogleReviewBadge />
      <InstallPrompt />
      {!hideChat && <ChatWidget />}
    </div>
  );
};

export default Layout;
